import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>At this time, this prior authorization cannot be completed. The earliest that this prescription can be filled is: {new Date(this.props.data.Greatest_Expiration_Date).toLocaleDateString()}. If you fill this prescription, the claim will not be paid.</p>
			</div>
		);
	}
}